import {
    Component,
    TemplateRef,
    ViewChild,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    OnDestroy
} from '@angular/core';
import { Subscription } from 'rxjs';
import { IconSize } from '../../core-data-model/IconSize';
import { IconType } from '../../core-data-model/IconType';
import { PeekService } from './Peek.service';

@Component({
    selector: 'peek-panel',
    template: `
        <ng-template #panelContent>
            <ng-content></ng-content>
        </ng-template>
    `,
    standalone: false
})
export class PeekPanelComponent implements OnChanges, OnDestroy {
    IconType = IconType;
    IconSize = IconSize;

    @Input()
    open = false;

    /**
     * When peek panel is open, noScroll = true will prevent the user
     * from being able to scroll the peek panel contents. The scroll bar
     * is hidden completely.
     */
    @Input()
    noScroll = false;

    /**
     * When a peek panel is closed, resetScrollToTop = true will reset the contents
     * so that next time the panel is opened, contents are scrolled back
     * to the top of the container
     */
    @Input()
    resetScrollToTop = false;

    /**
     * When a peek panel is open, showScrollBar = true shows the
     * panel's vertical scroll bar along-side the main body scroll bar.
     * This allows the user to manually scroll in the panel if they choose.
     */
    @Input()
    showScrollBar = false;

    @Output()
    close = new EventEmitter();
    @Output()
    panelOpened = new EventEmitter();

    @ViewChild('panelContent', { static: false })
    panelContent: TemplateRef<any>;

    subscription: Subscription;

    constructor(public peekService: PeekService) {
        this.subscription = this.peekService.open$.subscribe((isOpen) => {
            this.open = isOpen;
            if (!this.open) {
                this.close.emit();
            } else {
                this.panelOpened.emit();
            }
        });
    }

    ngOnChanges() {
        this.peekService.setOpen(this.open);
        this.peekService.setNoScroll(this.noScroll);
        this.peekService.setResetScrollToTop(this.resetScrollToTop);
        this.peekService.setShowScrollBar(this.showScrollBar);

        this.peekService.templateRef = this.panelContent;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.panelContent = null;
    }
}
